import React from "react";

interface IProps {
 label: string
}

const PageLoader = ({label}:IProps) => <div className="PageLoader"><label>{label}</label></div>

export default PageLoader
